// --
import React from 'react';
import AbstractReactComponent from "../AbstractReactComponent";

import "./NavIconText.scss";

/**
 * Komponenta ikony s nějakým textem (nebo komponentou), možné uspořádání - ikony vedle a ikona nad.
 */
class NavIconText extends AbstractReactComponent {
    static propTypes = {
        icon: React.PropTypes.node,
        text: React.PropTypes.node
    };

    render() {
        const {icon, text} = this.props;

        return (
            <div className="icon-text-wrapper">
                <div className="icon-text-container">
                    <div className="icon-text-icon">
                        {icon}
                    </div>
                    {text && <div className="icon-text-text">
                        {text}
                    </div>}
                </div>
            </div>
        )
    }
}

export default NavIconText;
